import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { appInsights } from "../util/AppInsights";

const AppInsightsRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    appInsights?.trackPageView({
      name: location.pathname,
    });
  }, [location, appInsights]);

  return null;
};

export default AppInsightsRouteTracker;
